<template>
  <SectionContainer class="container fluid-x">
    <SectionHeader>
      <template #title>
        <b>Cursos recém lançados</b>
      </template>
      
      <template #subtitle>
        Conteúdo relevante e atualizado criado apenas por experts
      </template>
    </SectionHeader>

    <HorizontalCarousel :items="coursesHighlight">
      <template v-slot="{ item }">
        <CourseThumbBox
          :course="item"
          class="course-thumb-box"
        />
      </template>
    </HorizontalCarousel>
  </SectionContainer>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import SectionContainer from '@/components/layout/SectionContainer'
  import SectionHeader from '@/components/layout/SectionHeader'
  import CourseThumbBox from '@/components/course/CourseThumbBox'
  import HorizontalCarousel from '@/components/carousel/HorizontalCarousel'

  export default {
    components: {
      SectionContainer,
      SectionHeader,
      CourseThumbBox,
      HorizontalCarousel,
    },
    computed: {
      ...mapGetters('course', ['coursesHighlight'])
    },
    async mounted () {
      this.fetchCoursesHighlight()
    },
    methods: {
      ...mapActions('course', ['fetchCoursesHighlight'])
    }
  }
</script>